/**
 * 데이터 로딩 중임을 표시하는 스피너 컴포넌트
 * 
 * 이 컴포넌트는 API 호출, 데이터 처리 등 비동기 작업 중에 사용자에게
 * 로딩 중임을 시각적으로 알려주는 스피너를 표시합니다.
 * Material UI의 CircularProgress를 활용하며, 선택적으로 메시지를 표시할 수 있습니다.
 * 
 * @param {Object} props
 * @param {string} [props.message='로딩 중...'] - 스피너 아래에 표시할 메시지
 * 
 * @example
 * // 기본 메시지 사용
 * <LoadingSpinner />
 * 
 * // 사용자 정의 메시지 사용
 * <LoadingSpinner message="데이터를 가져오는 중입니다..." />
 */

import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const LoadingSpinner = ({ message = '로딩 중...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: '200px',
      }}
    >
      <CircularProgress color="primary" />
      <Typography variant="body1" sx={{ mt: 2 }}>
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner; 